import { InputBaseStateType } from '@kubit/web-ui-components/inputBase/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { commonStyles } from '../commonStyles';
import { InputBaseVariantType } from '../variants';
export const getInputCurrencyConverterBaseRegularStyles = (FOUNDATIONS, FONT) => {
    const inputStyles = {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        text_overflow: 'ellipsis',
        white_space: 'nowrap',
    };
    return {
        [InputBaseVariantType.CURRENCY_CONVERTER_REGULAR]: {
            ...commonStyles(FOUNDATIONS, {
                [InputBaseStateType.FOCUSED]: {
                    input: inputStyles,
                },
                [InputBaseStateType.EMPTY]: { input: inputStyles },
                [InputBaseStateType.FILLED]: { input: inputStyles },
                [InputBaseStateType.ERROR_EMPTY]: { input: inputStyles },
                [InputBaseStateType.ERROR_FILLED]: { input: inputStyles },
                [InputBaseStateType.DISABLED_EMPTY]: { input: { ...inputStyles, cursor: 'default' } },
                [InputBaseStateType.DISABLED_FILLED]: { input: { ...inputStyles, cursor: 'default' } },
            }),
        },
    };
};
//# sourceMappingURL=currencyConverterRegular.js.map